



































import { Component, Prop, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ObserveVisibility } from 'vue-observe-visibility'

let uid = 0

const itemsLimit = 10000

@Component({
  directives: {
    ObserveVisibility
  }
})
export default class RecycleScroller extends ComponentVue {
  @Prop({
    type: Array,
    default: () => []
  })
  items: any

  @Prop({
    type: Number,
    default: 32
  })
  itemSize!: number

  @Prop({
    type: String,
    default: 'id'
  })
  keyField!: string

  @Prop({
    type: String,
    default: 'type'
  })
  typeField!: string

  @Prop({
    type: Number,
    default: 50
  })
  buffer!: number

  @Prop({
    type: Boolean,
    default: false
  })
  emitUpdate!: boolean

  @Prop({
    type: Number,
    default: 0
  })
  scrollTop!: number

  pool: any = []

  totalSize = 0

  ready = false

  hoverKey: any = null

  listenerTarget: any

  $startIndex: number = 0

  $endIndex: number = 0

  $views: any

  $unusedViews: any

  $scrollDirty = false

  $lastUpdateScrollPosition: number = 0

  $computedMinItemSize: number = 0

  $continuous = false

  $sortTimer: any

  _refreshTimout: any

  _computedMinItemSize: any

  @Watch('items')
  onChangeItems() {
    this.updateVisibleItems(true)
  }

  onResize() {
    this.$emit('resize')
    if (this.ready) this.updateVisibleItems(false)
  }

  created() {
    this.$startIndex = 0
    this.$endIndex = 0
    this.$views = new Map()
    this.$unusedViews = new Map()
    this.$scrollDirty = false
    this.$lastUpdateScrollPosition = 0
  }

  mounted() {
    this.$nextTick(() => {
      this.ready = true
    })
  }

  onScroll(event: { target: HTMLDivElement }) {
    if (!this.$scrollDirty) {
      this.$scrollDirty = true
      requestAnimationFrame(() => {
        this.$scrollDirty = false
        const continuous = this.updateVisibleItems(false, true)

        // It seems sometimes chrome doesn't fire scroll event :/
        // When non continous scrolling is ending, we force a refresh
        if (!continuous) {
          clearTimeout(this._refreshTimout)
          this._refreshTimout = setTimeout(this.onScroll, 100)
        }
      })
    }

    this.$emit('scroll', event.target.scrollTop)
  }

  beforeDestroy() {
    this.removeListeners()
  }

  addView(
    pool: any[],
    index: number,
    item: any,
    key: string | null,
    type: any
  ) {
    const view = {
      item,
      position: 0
    }
    const nonReactive = {
      id: uid++,
      index,
      used: true,
      key,
      type
    }
    Object.defineProperty(view, 'nr', {
      configurable: false,
      value: nonReactive
    })
    pool.push(view)
    return view
  }

  unUseView(view: any, fake = false) {
    const unusedViews = this.$unusedViews
    const type = view.nr.type
    let unusedPool = unusedViews.get(type)
    if (!unusedPool) {
      unusedPool = []
      unusedViews.set(type, unusedPool)
    }
    unusedPool.push(view)
    if (!fake) {
      view.nr.used = false
      view.position = -9999
      this.$views.delete(view.nr.key)
    }
  }

  onVisibilityChange(isVisible: any, entry: any) {
    if (this.ready) {
      if (
        isVisible ||
        entry.boundingClientRect.width !== 0 ||
        entry.boundingClientRect.height !== 0
      ) {
        this.$emit('visible')
        requestAnimationFrame(() => {
          this.updateVisibleItems(false)
        })
      } else {
        this.$emit('hidden')
      }
    }
  }

  updateVisibleItems(checkItem: boolean, checkPositionDiff = false) {
    const itemSize = this.itemSize
    const minItemSize = this.$computedMinItemSize
    const typeField = this.typeField
    const keyField = this.keyField
    const items = this.items
    const count = items.length
    // const sizes = this.sizes
    const views = this.$views
    const unusedViews = this.$unusedViews
    const pool = this.pool
    let startIndex = 0
    let endIndex = 0
    let totalSize

    if (!count) {
      startIndex = endIndex = totalSize = 0
    } else {
      const scroll = this.getScroll()

      // Skip update if use hasn't scrolled enough
      if (checkPositionDiff) {
        let positionDiff = scroll.start - this.$lastUpdateScrollPosition
        if (positionDiff < 0) positionDiff = -positionDiff
        if (
          (itemSize === null && positionDiff < minItemSize) ||
          positionDiff < itemSize
        ) {
          return {
            continuous: true
          }
        }
      }
      this.$lastUpdateScrollPosition = scroll.start

      const buffer = this.buffer
      scroll.start -= buffer
      scroll.end += buffer

      // Fixed size mode
      startIndex = ~~(scroll.start / itemSize)
      endIndex = Math.ceil(scroll.end / itemSize)

      // Bounds
      startIndex < 0 && (startIndex = 0)
      endIndex > count && (endIndex = count)

      totalSize = count * itemSize
    }

    if (endIndex - startIndex > itemsLimit) {
      this.itemsLimitError()
    }

    this.totalSize = totalSize

    let view: any

    const continuous =
      startIndex <= this.$endIndex && endIndex >= this.$startIndex

    if (this.$continuous !== continuous) {
      if (continuous) {
        views.clear()
        unusedViews.clear()
        for (let i = 0, l = pool.length; i < l; i++) {
          view = pool[i]
          this.unuseView(view)
        }
      }
      this.$continuous = continuous
    } else if (continuous) {
      for (let i = 0, l = pool.length; i < l; i++) {
        view = pool[i]
        if (view.nr.used) {
          // Update view item index
          if (checkItem) {
            view.nr.index = items.findIndex((item: any) =>
              keyField
                ? item[keyField] === view.item[keyField]
                : item === view.item
            )
          }

          // Check if index is still in visible range
          if (
            view.nr.index === -1 ||
            view.nr.index < startIndex ||
            view.nr.index >= endIndex
          ) {
            this.unUseView(view)
          }
        }
      }
    }

    // const unusedIndex = continuous ? null : new Map()
    const unusedIndex = new Map()

    let item, type, unusedPool
    let v
    for (let i = startIndex; i < endIndex; i++) {
      item = items[i]
      const key = keyField ? item[keyField] : item
      if (key == null) {
        throw new Error(`Key is ${key} on item (keyField is '${keyField}')`)
      }
      view = views.get(key)

      // if (!itemSize && !sizes[i].size) {
      //   if (view) this.unuseView(view)
      //   continue
      // }

      // No view assigned to item
      if (!view) {
        type = item[typeField]
        unusedPool = unusedViews.get(type)

        if (continuous) {
          // Reuse existing view
          if (unusedPool && unusedPool.length) {
            view = unusedPool.pop()
            view.item = item
            view.nr.used = true
            view.nr.index = i
            view.nr.key = key
            view.nr.type = type
          } else {
            view = this.addView(pool, i, item, key, type)
          }
        } else {
          // Use existing view
          // We don't care if they are already used
          // because we are not in continous scrolling
          v = unusedIndex.get(type) || 0

          if (!unusedPool || v >= unusedPool.length) {
            view = this.addView(pool, i, item, key, type)
            this.unuseView(view, true)
            unusedPool = unusedViews.get(type)
          }

          view = unusedPool[v]
          view.item = item
          view.nr.used = true
          view.nr.index = i
          view.nr.key = key
          view.nr.type = type
          unusedIndex.set(type, v + 1)
          v++
        }
        views.set(key, view)
      } else {
        view.nr.used = true
        view.item = item
      }

      // Update position
      view.position = i * itemSize
    }

    this.$startIndex = startIndex
    this.$endIndex = endIndex

    if (this.emitUpdate) this.$emit('update', startIndex, endIndex)

    // After the user has finished scrolling
    // Sort views so text selection is correct
    clearTimeout(this.$sortTimer)
    this.$sortTimer = setTimeout(this.sortViews, 300)

    return {
      continuous
    }
  }

  unuseView(view: any, fake = false) {
    const unusedViews = this.$unusedViews
    const type = view.nr.type
    let unusedPool = unusedViews.get(type)
    if (!unusedPool) {
      unusedPool = []
      unusedViews.set(type, unusedPool)
    }
    unusedPool.push(view)
    if (!fake) {
      view.nr.used = false
      view.position = -9999
      this.$views.delete(view.nr.key)
    }
  }

  getListenerTarget() {
    return window.document.documentElement
    // let target = ScrollParent(this.$el)
    // // Fix global scroll target for Chrome and Safari
    // if (window.document && (target === window.document.documentElement || target === window.document.body)) {
    //   target = window
    // }
    // return target
  }

  getScroll() {
    const { $el: el } = this
    return {
      start: el.scrollTop,
      end: el.scrollTop + el.clientHeight
    }
  }

  addListeners() {
    this.listenerTarget = this.getListenerTarget()
    // this.listenerTarget.addEventListener(
    //   'scroll',
    //   this.onScroll,
    //   supportsPassive
    //     ? {
    //       passive: true
    //     }
    //     : false
    // )
    this.listenerTarget.addEventListener('scroll', this.onScroll)
    this.listenerTarget.addEventListener('resize', this.onResize)
  }

  removeListeners() {
    if (!this.listenerTarget) {
      return
    }

    this.listenerTarget.removeEventListener('scroll', this.onScroll)
    this.listenerTarget.removeEventListener('resize', this.onResize)

    this.listenerTarget = null
  }

  scrollToItem(index: number) {
    // let scroll
    // if (this.itemSize === null) {
    //   scroll = index > 0 ? this.sizes[index - 1].accumulator : 0
    // } else {
    //   scroll = index * this.itemSize
    // }
    // this.scrollToPosition(scroll)
    this.$el.scrollTop = index * this.itemSize
  }

  // scrollToPosition(position) {
  //   if (this.direction === 'vertical') {
  //     this.$el.scrollTop = position
  //   } else {
  //     this.$el.scrollLeft = position
  //   }
  // }

  itemsLimitError() {
    setTimeout(() => {
      console.log(
        "It seems the scroller element isn't scrolling, so it tries to render all the items at once.",
        'Scroller:',
        this.$el
      )
      console.log(
        "Make sure the scroller has a fixed height (or width) and 'overflow-y' (or 'overflow-x') set to 'auto' so it can scroll correctly and only render the items visible in the scroll viewport."
      )
    })
    throw new Error('Rendered items limit reached')
  }

  sortViews() {
    this.pool.sort((viewA: any, viewB: any) => viewA.nr.index - viewB.nr.index)
  }
}
